var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMembership(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 54,
    viewBox: "0 0 68 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6C2 3.79086 3.79086 2 6 2H62C64.2091 2 66 3.79086 66 6V48C66 50.2091 64.2091 52 62 52H6C3.79086 52 2 50.2091 2 48V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6C0 2.68629 2.68629 0 6 0H62C65.3137 0 68 2.68629 68 6V48C68 51.3137 65.3137 54 62 54H6C2.68629 54 0 51.3137 0 48V6ZM6 4C4.89543 4 4 4.89543 4 6V48C4 49.1046 4.89543 50 6 50H62C63.1046 50 64 49.1046 64 48V6C64 4.89543 63.1046 4 62 4H6Z",
    fill: "#2F343D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12C8 9.79086 9.79086 8 12 8H16C18.2091 8 20 9.79086 20 12V16C20 18.2091 18.2091 20 16 20H12C9.79086 20 8 18.2091 8 16V12ZM16 12H12V16H16V12Z",
    fill: "#2F343D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 34C8 32.8954 8.89543 32 10 32H17C18.1046 32 19 32.8954 19 34C19 35.1046 18.1046 36 17 36H10C8.89543 36 8 35.1046 8 34Z",
    fill: "#FF4935"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 34C22 32.8954 22.8954 32 24 32H31C32.1046 32 33 32.8954 33 34C33 35.1046 32.1046 36 31 36H24C22.8954 36 22 35.1046 22 34Z",
    fill: "#FF4935"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 34C36 32.8954 36.8954 32 38 32H45C46.1046 32 47 32.8954 47 34C47 35.1046 46.1046 36 45 36H38C36.8954 36 36 35.1046 36 34Z",
    fill: "#FF4935"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 34C50 32.8954 50.8954 32 52 32H59C60.1046 32 61 32.8954 61 34C61 35.1046 60.1046 36 59 36H52C50.8954 36 50 35.1046 50 34Z",
    fill: "#FF4935"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 42C8 40.8954 8.89543 40 10 40H26C27.1046 40 28 40.8954 28 42C28 43.1046 27.1046 44 26 44H10C8.89543 44 8 43.1046 8 42Z",
    fill: "#2F343D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 11C24 9.89543 24.8954 9 26 9H41C42.1046 9 43 9.89543 43 11C43 12.1046 42.1046 13 41 13H26C24.8954 13 24 12.1046 24 11Z",
    fill: "#FF4935"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 17C24 15.8954 24.8954 15 26 15H36C37.1046 15 38 15.8954 38 17C38 18.1046 37.1046 19 36 19H26C24.8954 19 24 18.1046 24 17Z",
    fill: "#FF4935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembership);
export default __webpack_public_path__ + "static/media/membership.b9b0882566a1f81daa2cf792e256c880.svg";
export { ForwardRef as ReactComponent };